import mapProps from '../scripts/utils/map-props';
import CheckboxGroup from './checkbox-group';

export default mapProps(
  [
    'value',
  ],
  {
    model: {
      prop: 'value',
      event: 'change',
    },
  }
)(CheckboxGroup);
